<template>
  <form>
    <LoadingOverlay
        :activeSyncProps="activeSync"
        :isFullPageProps="true"
    />
    <ul class="set_signup_form">
      <li
          v-for="(field, index_i) in fields"
          :key="index_i"
          :class="field.class"
      >
        <label
            v-for="(item, index_j) in field.items"
            :key="index_j"
            :for="item.id"
            class="member_input"
            :style="item.id === 'sign' ? 'width:60%;' : ''"
        >
          <input
              v-if="item.type !== 'select'"
              :id="item.id"
              :class="`${item.id} ${item.class}`"
              :type="item.type"
              :autocomplete="item.autocomplete"
              :maxlength="item.maxlength"
              v-model="item.value"
              @input="item.inputEvent(item, index_i, index_j)"
              @blur="item.blurEvent(item, index_i, index_j)"
          />
          <select
              v-else
              :class="item.class"
              v-model="item.value"
              @change="item.event(item, index_i, index_j)"
              @blur="item.event(item, index_i, index_j)"
          >
            <option
                v-for="(option, i) in item.options"
                :key="i"
                :value="option.value"
                :disabled="option.disabled"
            >
              {{ $t(`${option.label}`) }}
            </option>
          </select>
          <span class="label">
            {{ $t(`${item.title}`) }}
            <span class="txt_red">
              {{ item.required ? '*' : '' }}
            </span>
          </span>
          <span
              v-if="item.description !== undefined && (item.id === 'password' || (!item.validation && item.class === red))"
              :class="item.class === red ? 'description red' : 'description'"
          >
              ※ {{ $t(`${item.description}`) }}
          </span>
          <div
              class="sign-form"
              v-show="field.items[0].id === 'sign'"
          >
            <div
                class="sign-img"
                :id="'signImg' + index_i"
                @click="handleClick"
            >
              <div class="text">
                By :
              </div>
              {{field.items[0].value}}
            </div>
          </div>
        </label>
        <SignUpBlindIcon
            v-if="field.items[0].id === 'password' || field.items[0].id === 'confirmPassword'"
            :index_i="index_i"
            @togglePasswordShow="togglePasswordShow"
        />
      </li>
      <div style="display: none">
        {{ computedAllValidation }}
      </div>
    </ul>
  </form>
</template>
<script>
import {
  toPng,
} from "html-to-image";
import _API from '@/api';
import SignUpBlindIcon from './signUpBlindIcon.vue';
import validationMethods from '@/common/lib/validation.js'
import LoadingOverlay from "../../loadingOverlay";

export default {
  name: 'SignUpForm',
  components: {
    LoadingOverlay,
    SignUpBlindIcon,
  },
  data() {
    return {
      red: 'red_wrong',
      activeSync: false,
      fields: [
        {
          index: 0,
          class: 'label_double',
          items: [
            {
              id: 'firstName',
              class: '',
              title: 'user.your_name',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              maxlength: 50,
              description: 'account.name_validation',
              autocomplete: 'given-name',
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
            {
              id: 'email',
              class: '',
              title: 'user.email',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              description: 'account.email_form_mismatch',
              autocomplete: 'email',
              inputEvent: () => { /* This is intentional */
              },
              blurEvent: this.checkEachValidation
            }
          ]
        },
        {
          index: 1,
          class: 'relative',
          items: [
            {
              id: 'sign',
              class: '',
              title: 'user.sign',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              maxlength: 8,
              autocomplete: 'sign',
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            }
          ]
        },
        {
          index: 2,
          class: 'relative',
          items: [
            {
              id: 'password',
              class: '',
              title: 'user.password',
              type: 'password',
              value: '',
              required: true,
              validation: false,
              description: 'account.password_form',
              autocomplete: 'new-password',
              maxlength: 50,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
          ]
        },
        {
          index: 3,
          class: 'relative',
          items: [
            {
              id: 'confirmPassword',
              class: '',
              title: 'user.confirm_password',
              type: 'password',
              value: '',
              required: true,
              validation: false,
              description: 'account.password_re_same',
              autocomplete: 'new-password',
              maxlength: 50,
              inputEvent: this.checkEachValidation,
              blurEvent: this.checkEachValidation
            },
          ]
        },
        // {
        //   index: 0,
        //   class: 'top',
        //   items: [
        //     {
        //       id: 'title',
        //       class: '',
        //       title: 'user.title',
        //       type: 'select',
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.select_title',
        //       event: this.checkEachValidation,
        //       options: [
        //         {
        //           disabled: true,
        //           value: '',
        //           label: 'account.select_title'
        //         },
        //         {
        //           disabled: false,
        //           value: 33,
        //           label: 'user.name'
        //         },
        //         {
        //           disabled: false,
        //           value: 34,
        //           label: 'user.email'
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   index: 1,
        //   class: 'label_double',
        //   items: (localStorage.getItem('lang') ?? 'en') === 'ko-kr' ? [
        //     {
        //       id: 'lastName',
        //       class: '',
        //       title: 'user.last_name',
        //       type: 'text',
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.last_name_validation',
        //       autocomplete: 'family-name',
        //       event: this.checkEachValidation
        //     },
        //     {
        //       id: 'firstName',
        //       class: '',
        //       title: 'user.first_name',
        //       type: 'text',
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.first_name_validation',
        //       autocomplete: 'given-name',
        //       event: this.checkEachValidation
        //     },
        //   ] : [
        //     {
        //       id: 'firstName',
        //       class: '',
        //       title: 'user.first_name',
        //       type: 'text',
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.first_name_validation',
        //       autocomplete: 'given-name',
        //       event: this.checkEachValidation
        //     },
        //     {
        //       id: 'lastName',
        //       class: '',
        //       title: 'user.last_name',
        //       type: 'text',
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.last_name_validation',
        //       autocomplete: 'family-name',
        //       event: this.checkEachValidation
        //     },
        //   ]
        // },
        // {
        //   index: 5,
        //   class: 'bottom',
        //   items: [
        //     {
        //       id: 'npi',
        //       class: '',
        //       title: 'user.npi_number',
        //       type: 'text',
        //       maxlength: 10,
        //       value: '',
        //       required: true,
        //       validation: false,
        //       description: 'account.npi_required',
        //       event: this.checkEachValidation
        //     }
        //   ]
        // }
      ],
    }
  },
  computed: {
    computedAllValidation() {
      let result = true;
      this.fields.forEach(value => {
        value.items.some(({validation}) => {
          if (validation === false) {
            result = validation;
            return !validation;
          }
        });
      });
      this.$emit('checkAllValidation', result);
      return result
    }
  },
  methods: {
    ...validationMethods,
    /**
     *  각 필드를 사용자가 클릭 후 떠나면 (@blur) or (@change, @input)
     *  유효성을 체크한다.
     * @param id
     * @param value
     * @param index_i
     * @param index_j
     */
    checkEachValidation({id, value}, index_i, index_j) {
      let validationCheck = false;
      switch (id) {
        case 'title' :
          validationCheck = (value !== '');
          break;
        case 'firstName' :
          validationCheck = this.checkNameValidation(value);
          break;
        case 'lastName' :
          validationCheck = this.checkNameValidation(value);
          break;
        case 'email' : // validation : 형식이 맞으면 중복 여부 확인
          validationCheck = this.checkEmailValidation(value);
          if (validationCheck) {
            this.activeSync = true;
            this.checkIfUsingEmail(value).then(res => {
              validationCheck = res;
              if (!res) {
                // 중복된 멜이라는 경고문구
                this.fields[index_i].items[index_j].description = 'account.email_already_exist';
              }
              this.changeValidation(validationCheck, index_i, index_j);
              this.activeSync = false;
            })
          } else {
            // 형식이 틀리다는 경고 문구
            this.fields[index_i].items[index_j].description = 'account.email_form_mismatch';
          }
          break;
        case 'password' :
          const banList = [
            this.fields[0]?.items[0]?.value,
            this.fields[0]?.items[1]?.value,
          ];

          validationCheck = this.checkPasswordValidation(value, banList).result;
          // 비밀번호 확인에 값이 있다면, 확인이랑 일치하는 지 여부도 확인
          if (this.fields[index_i + 1].items[index_j].value !== '') {
            this.checkEachValidation({id: 'confirmPassword', value: this.fields[index_i + 1].items[index_j].value},
                index_i + 1, index_j
            )
          }
          break;
        case 'confirmPassword' :
          validationCheck = this.fields[index_i - 1].items[index_j].value !== '' && this.fields[index_i - 1].items[index_j].value === value;
          break;
        case 'npi' :
          validationCheck = this.checkNipValidation(value);
          break;
        case 'sign' :
          validationCheck = value.length !== 0;
          break;
        default :
          break;
      }

      this.changeValidation(validationCheck, index_i, index_j);
    },
    /**
     *  email 을 받아, 서버에 중복 확인 요청을 날린다.
     *  사용가능한 메일일 경우 ture 를, 중복된 이메일일 경우 false 를 반환한다.
     * @param value
     * @returns {Promise<unknown>}
     */
    async checkIfUsingEmail(value) {
      return new Promise(resolve => {
        _API.ACCOUNT.validateUserEmail(value).then(({data}) => {
          resolve(data.isSuccess);
        })
      });
    },
    /**
     * 비밀번호의 input 타입을 변경해, 보여주거나 감춘다.
     * @param booleans
     */
    togglePasswordShow(booleans, index_i) {
      if (booleans) {
        this.fields[index_i].items[0].type = 'text';
      } else {
        this.fields[index_i].items[0].type = 'password';
      }
    },
    /**
     * fields 에 index_i, index_j 에 해당하는 아이템의 유효성 상태와
     * 클래스를 변경한다. (빨강 경고 문구 표기)
     * @param validationCheck
     * @param index_i
     * @param index_j
     */
    changeValidation(validationCheck, index_i, index_j) {
      this.fields[index_i].items[index_j].class = validationCheck ? '' : this.red;
      this.fields[index_i].items[index_j].validation = validationCheck;
    },
    /**
     * 상위 컴포넌트에서 하위 컴포넌트의 input 데이터를 get
     */
    getFieldsValue() {
      return this.fields
    },
    handleClick() {
      if (this.fields[1]?.items[0]?.value?.length !== 0)
        toPng(document.getElementById('signImg1'), {cacheBust: true,})
            .then((dataUrl) => {
              let link = document.createElement('a');
              link.download = 'sign.png';
              link.href = dataUrl;
              link.click();
            })
            .catch((err) => {
              console.log(err);
            })
    }
  }
}
</script>
<style lang="scss">
.sign-form {
  position: absolute;
  right: -222px;
  top: -8px;
}

.sign-img {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-family: Nanum Brush Script, cursive;
  font-size: 25px;
  background-color: #ffffff;
  border-bottom: 2px solid;

  .text {
    position: absolute;
    padding-top: 14px;
    font-size: 14px;
  }
}

.set_signup_form {
  li {
    label {
      input {
        box-sizing: border-box;
      }
    }
  }

  .member_input {
    @media screen and (min-width: 320px) and (max-width: 600px) {
      width: 100% !important;

      .sign-form {
        margin-top: 5px;
        display: block;
        position: unset;

        .sign-img{
          width: 100%;
        }
      }
    }

    .password, .confirmPassword {
      padding-right: 65px !important;
      width: 100% !important;
    }

    ::-ms-reveal {
      display: none;
    }
  }
}
</style>